import React from 'react'

import PageHeader from '@/components/misc/PageHeader'
import { ScrollableTab } from '@/components/misc/ScrollableTabs'
import { Badge } from '@/components/ui/badge'
import { useNotificationsCount } from '@/hooks/useNotificationsCount'
import { usePermissions } from '@/hooks/usePermissions'
import { ROUTES } from '@/lib/routes'

const ProfessionalNetworkPageHeader: React.FC = () => {
  const permissions = usePermissions()
  const notificationsCount = useNotificationsCount()

  const tabs: ScrollableTab[] = [
    {
      label: (
        <div className="flex items-center justify-center gap-2">
          Your relationships
          {notificationsCount.relationships > 0 && (
            <Badge>{notificationsCount.relationships}</Badge>
          )}
        </div>
      ),
      to: ROUTES.professionalNetworkRelationships(),
    },
  ]

  if (permissions.canInviteToPanel) {
    tabs.push({
      label: 'Invite',
      to: ROUTES.professionalNetworkInvite(),
    })
  }

  tabs.push(
    {
      label: 'Stats',
      to: ROUTES.professionalNetworkStats(),
    },
    {
      label: 'Revenue',
      to: ROUTES.professionalNetworkRevenue(),
    },
    {
      label: 'Approval management',
      to: ROUTES.professionalNetworkApprovalManagement(),
    },
    {
      label: (
        <div className="flex items-center justify-center gap-2">
          Approval requests
          {notificationsCount.approvalRequests > 0 && (
            <Badge>{notificationsCount.approvalRequests}</Badge>
          )}
        </div>
      ),
      to: ROUTES.professionalNetworkApprovalRequests(),
    },
    {
      label: 'Onboarding',
      to: ROUTES.professionalNetworkOnboarding(),
    },
  )

  return <PageHeader title="Your network" tabs={tabs} className="mb-6" />
}

export default ProfessionalNetworkPageHeader
